import type { AiVisibilitySummary, Organization } from '@cmoh/shared'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/axios'

export type ActiveOrganization = Organization & {
  aiVisibility: AiVisibilitySummary | null
}

/**
 * Hook to get the current user's active organization.
 */
export function useCurrentOrganization({ enabled = true }: { enabled?: boolean } = {}) {
  const {
    data: currentOrganization,
    isLoading: isLoadingOrganization,
    error: errorOrganization,
  } = useQuery({
    queryKey: ['current-organization'],
    queryFn: async () => {
      const response = await apiClient.get<{ data: ActiveOrganization | null }>(
        '/organization/active',
      )
      return response.data.data
    },
    enabled,
  })

  return {
    organization: currentOrganization ?? null,
    isLoading: isLoadingOrganization,
    error: errorOrganization,
  }
}
